import React, { useState } from "react"
import { Form, Input } from "antd"
import { useHistory, useRouteMatch } from "react-router-dom"
import shortid from "shortid"
import request from "lib/request"
import { endpoints } from "config/endpoints.config"
import toast from "lib/toast"
import EmailSmtpImapCore from "./EmailSmtpImapCore"
import FormModal from "components-old/forms/FormModal"
import { channelsDef } from "../channels.def"
import StarAlert from "../StarAlert"
import { isAldeia } from "hooks/useAldeia"

function AddEmail() {
  const [form] = Form.useForm()
  // const [saving, setSaving] = useState(false)
  const history = useHistory()
  const match = useRouteMatch()
  const isForward = match.path === "/settings/channels/new/email/forward"
  const [open, setOpen] = useState(true)

  const close = (cb: () => void) => {
    setOpen(false)
    // setTimeout(() => {
    cb()
    // }, 150)
  }

  return (
    <FormModal
      form={form}
      visible={open}
      // noPrompt
      onSubmit={async (model: any) => {
        return request.post(endpoints.EMAIL, isForward ? model : { ...model, identifier: model.extraData.imapData.auth.user }).then((a) => {
          toast.success("Canal de E-mail criado.")
          history.push("/settings/channels/" + a.data.id)
        })
      }}
      defaultValues={
        isForward
          ? {
              identifier: shortid.generate() + "kinbox@mail.kinbox.com.br",
            }
          : {}
      }
      onBack={() => close(() => history.push("/settings/channels/new/email"))}
      type="drawer"
      width={600}
      titleOverwrite={
        <span className="flex gap-3 items-center text-lg">
          <div className="size-8">{channelsDef.record["email"]?.icon}</div>
          Conectar E-mail
        </span>
      }
      // stickyFooter
      onSubmitSuccess={() => {
        history.push("/settings/channels")
      }}
      okText="Conectar canal"
      stickyFooter={!isForward}
    >
      {isAldeia ? (
        <>
          <StarAlert className="!px-3 mb-4 gap-3" type="info">
            {isForward ? (
              <div className="text-sm">
                {isForward && (
                  <>
                    <p>
                      <strong>Encaminhamento: </strong>O processo é simples, apenas habilite "forwarding" nas configurações do seu provedor
                      de e-mail e redirecione para o endereço que irá aparecer depois de criado esse canal.
                    </p>
                  </>
                )}
              </div>
            ) : (
              <div className="text-sm">
                <p>
                  Você pode ler e responder mensagens que seus clientes enviam para o e-mail existente do seu time (e.g:
                  contato@suaempresa.com) diretamente na {isAldeia ? "Aldeia" : "Kinbox"}.
                </p>
              </div>
            )}
          </StarAlert>
        </>
      ) : (
        <div className="text-sm">
          <p>
            Você pode ler e responder mensagens que seus clientes enviam para o e-mail existente do seu time (e.g: contato@suaempresa.com)
            diretamente no {isAldeia ? "Aldeia" : "Kinbox"}.
          </p>
          {isForward && (
            <>
              <br />
              <p>
                O processo é simples, apenas habilite "forwarding" nas configurações do seu provedor de e-mail e redirecione para o endereço
                que irá aparecer depois de criado esse canal.
              </p>
            </>
          )}
        </div>
      )}
      {isForward && (
        <Form.Item
          label="Descrição"
          name="description"
          rules={[
            {
              required: true,
              message: "Campo obrigatório",
            },
          ]}
        >
          <Input placeholder="contato@suaempresa.com" />
        </Form.Item>
      )}
      <Form.Item
        label="Configurações de Encaminhamento"
        name="identifier"
        help="Para receber as mensagens que seus clientes enviam para seu e-mail existente, vá para as configurações do seu provedor de email e habilite encaminhamento (forwarding) de todas as mensagens para o endereço especial acima."
        className="hidden"
      >
        <Input disabled />
      </Form.Item>
      {!isForward && (
        <>
          <EmailSmtpImapCore />
        </>
      )}
    </FormModal>
  )
}

export default AddEmail
